<template>
    <!-- 未来lab -->
    <div class="website-css">
        <MenuHead @func="getMsgFormSon"></MenuHead>
        <!--顶部-->
        <div class="head-bg">
            <div style="position: relative">
                <div style="position:absolute;width: 50%;height:100px;">
                    <p class="head-left-f1  animated fadeInLeft">每天十分钟</p>
                    <p class="head-left-f2  animated fadeInLeft">练就小天才</p>
                    <p class="head-left-f3  animated fadeInLeft">扫码下载超级记忆力app</p>
                    <img class="head-qr-code  animated fadeInLeft"
                         src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/Website/wlsw-qr-code.png"/>
                </div>
                <div style="position:absolute;width: 50%;margin-left:50%;height:100px;">
                    <img class="head-img animated pulse"
                         src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/wlsx-web/i10.png"/>x
                </div>
            </div>
        </div>
        <!--中间内容-->
        <div class="content">
            <div style="position: relative">
                <p class="font-content-t">下载小惊喜</p>
                <p class="font-content-st">现在下载还可前往【家长课堂】学习育儿宝典也可以和宝贝一起参与盲盒活动哦~</p>
                <div class="animated fadeIn" style="width: 100%;text-align: center;padding-top: 0.5rem">
                    <img class="content-img"
                         src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/wlsx-web/i7.png"/>
                </div>
            </div>
        </div>
        <!-- 媒体关注与报道 end -->
        <web-bottom ref="child"></web-bottom>
    </div>
</template>
<script>
    import '../assets/style/Public-css/img-style.css'
    import ChineseJson from '../assets/json/Chinese-Json.json'
    import EnglishJson from '../assets/json/English-Json.json'
    import MenuHead from '../components/MenuHead'
    import WebBottom from '../components/WebBottom'

    export default {
        metaInfo: {
            title: '解决方案-北京大象智酷科技有限公司', // set a title
            meta: [
                // set meta
                {
                    name: 'keyWords',
                    content: '大脑能力评估,脑科学,神经科学',
                },
                {
                    name: 'description',
                    content:
                        '大象智酷科研团队依靠认知神经科学、脑科学、认知心理学等学科成熟理论,以数字云平台的大数据为依托,为不同行业群体提供针对性大脑能力评估和提升一体化方案.通过全方位、多能力的认知能力测试,实时采集相应数据,提供专业反馈信息和提升建议,用脑科学提升行业人群质量,赋能行业发展.',
                },
            ],
            // link: [{                 // set link
            //  		rel: 'asstes',
            //   	href: 'https://assets-cdn.github.com/'
            // }]
        },
        name: 'Solution',
        components: {
            MenuHead,
            WebBottom,
        },

        data() {
            return {
                ChineseJson: JSON.parse(JSON.stringify(ChineseJson)), //中文配表
                EnglishJson: JSON.parse(JSON.stringify(EnglishJson)), //英文配表
                languageJson: [],
                languageList: [],
            }
        },
        props: {
            msg: String,
        },
        created() {
            // this.langtype = localStorage.getItem("LanguageTypes");
            // console.log("语言类型", this.langtype);
            // this.IFType();
            if (localStorage.getItem('LanguageTypes') == undefined) {
                this.langtype = 1
                this.IFType()
            } else {
                this.langtype = localStorage.getItem('LanguageTypes')
                console.log('语言类型', this.langtype)
                this.IFType()
            }
        },
        mounted() {
        },
        methods: {
            IFType() {
                if (this.langtype == 1) {
                    this.languageJson = this.ChineseJson
                    console.log('中文配表', this.languageJson)
                    this.getList()
                } else {
                    this.languageJson = this.EnglishJson
                    this.getList()
                }
            },
            getMsgFormSon(data) {
                // this.msgFormSon = data;
                console.log('home', data)
                this.langtype = data
                this.IFType()
                this.$refs.child.sing(this.langtype)
            },
            getList() {
                // this.ChineseJson.fo
                this.languageJson.forEach((item) => {
                    if (item.title == 'Solution') {
                        this.languageList = item.List
                    }
                })
            },
        },
    }
</script>
<style scoped>
    .head-bg {
        background: -webkit-linear-gradient(top, #2E94F6, #6bbbfa);
        height: 5rem;
    }

    .head-left-f1 {
        position: absolute;
        right: 1rem;
        font-weight: bolder;
        font-size: 0.35rem;
        top: 1.5rem;
        color: white;
    }

    .head-left-f2 {
        position: absolute;
        right: 1rem;
        font-weight: bolder;
        font-size: 0.35rem;
        top: 2rem;
        color: white;
    }

    .head-left-f3 {
        position: absolute;
        right: 1.58rem;
        font-size: 0.12rem;
        top: 2.7rem;
        color: #F2F2F2;
    }

    .head-qr-code {
        position: absolute;
        right: 1.7rem;
        top: 2.9rem;
        width: 1rem;
        height: 1rem;
    }

    .head-img {
        position: absolute;
        left: 1.5rem;
        top: 1.2rem;
        width: 3rem;
        height: 3rem;
    }


    .AboutUs-banner-block img {
        height: 100%;
        width: 100%;
    }

    .AboutUs-banner-BSYD .banner-title p {
        color: #ffffff;
    }

    .Solution-banner .w1200 {
        height: 100%;
    }

    .Solution-banner .wlzg-banner-logo {
        margin-top: 150px;
    }

    .brain-ul li {
        float: left;
        width: 400px;
        height: 300px;
    }

    .school-ul li {
        display: inline-block;
        margin-left: 59px;
        text-align: center;

        flex: 1;
    }

    .school-ul li:nth-of-type(1) {
        margin-left: 0px;
    }

    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }

    .content {
        color: white;
        height: 4rem;
    }

    .font-content-t {
        color: black;
        font-size: 0.25rem;
        font-weight: bold;
        padding-top: 0.3rem;
        width: 100%;
        text-align: center;
    }

    .font-content-st {
        color: #222222;
        font-size: 0.14rem;
        padding-top: 0.1rem;
        width: 100%;
        text-align: center;
    }

    .content-img {
        width: 7.3rem;
        height: 1.68rem;
    }
</style>